<template>
    <v-date-picker
      :popover="{visibility: 'focus'}"
      :columns="calendarLayout.columns"
      :rows="calendarLayout.rows"
      :is-expanded="calendarLayout.isExpanded"
      :value="selectedDate"
      @input="handleInput"
      :input-props="inputProps"
      :min-date="minDate"
      :max-date="maxDate"
      :masks="masks"
    ></v-date-picker>
</template>

<script>
export default {
  data () {
    return {
      selectedDate: this.date
    }
  },
  props: {
    date: {
      default: () => (new Date()),
      type: String | Date,
      required: false
    },
    inputProps: {
      default: () => ({}),
      type: Object,
      required: false
    },
    masks: {
      default: () => ({
        input: 'DD/MM/YYYY'
      }),
      type: Object,
      required: false
    },
    minDate: {
      type: String | Date,
      required: false
    },
    maxDate: {
      type: String | Date,
      required: false
    }
  },
  computed: {
    calendarLayout () {
      return this.$screens(
        {
          // Default layout for mobile
          default: {
            columns: 1,
            rows: 1,
            isExpanded: true
          }
        }
      )
    }
  },
  methods: {
    handleInput (val) {
      let original = this.selectedDate
      if (val !== null) {
        // Convert yyyy-mm-dd string to Date object
        if (!(this.selectedDate instanceof Date) && this.selectedDate !== null) {
          val = new Date(this.selectedDate)
        }
        let day = String(val.getDate()).padStart(2, '0')
        let month = String(val.getMonth() + 1).padStart(2, '0')
        let year = val.getFullYear()
        this.$emit('update:date', year + '-' + month + '-' + day)
        this.$emit('input', year + '-' + month + '-' + day)
      } else {
        this.$emit('update:date', val)
      }
      if (!this.inputProps.placeholder) {
        this.inputProps.placeholder = ''
      }
      let placeholder = this.inputProps.placeholder.replace(' ', '-').toLowerCase()
      this.$emit('change', original, val, placeholder)
    }
  },
  mounted () {
    // Convert yyyy-mm-dd string to Date object
    if (!(this.date instanceof Date) && this.date !== null) {
      this.selectedDate = new Date(this.date)
    }
    if (this.selectedDate) {
      let day = String(this.selectedDate.getDate()).padStart(2, '0')
      let month = String(this.selectedDate.getMonth() + 1).padStart(2, '0')
      let year = this.selectedDate.getFullYear()
      this.$emit('update:date', year + '-' + month + '-' + day)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Calendar.vue